module.exports = __webpack_public_path__ + "436c1ecdb3bac04f98ca189e87d54216.png";